// Схлопывание одинаковых картинок в payload'е сохранения макета.
//
// Одна и та же картинка, разложенная на несколько деталей (перед/спинка/рукава),
// экспортируется отдельным слоем на каждую деталь, и каждый слой тащил свою копию
// base64. На лонгсливе (4 детали) это давало ×4 к весу: файл на 60 МБ превращался
// в запрос на 305 МБ, который резал nginx (413).
//
// Здесь base64 остаётся только у ПЕРВОГО вхождения, остальные слои ссылаются на него
// индексом в этом же массиве (`image_same_as`). Сервер вешает на них тот же блоб.
export function dedupeImageData(layers) {
  const firstIndexBySrc = new Map()
  return layers.map((l, i) => {
    if (!l.image_data) return l
    const first = firstIndexBySrc.get(l.image_data)
    if (first === undefined) {
      firstIndexBySrc.set(l.image_data, i)
      return l
    }
    const { image_data, ...rest } = l
    return { ...rest, image_same_as: first }
  })
}
